module.exports = __webpack_public_path__ + "static/media/Antibody-2.a566f52b.jpg";